import { ListItemsResponse, SearchAllPreoffersBody, PreofferItemResponse } from '@innowise-group/core';
import type { AxiosResponse } from 'axios';
import { $api } from '../axios/axios';
import qs from 'qs';

export default class PreoffersService {
  static async searchAllPreoffers(args: {
    params: {
      currentPage: number;
      pageSize: number;
    };
    body?: SearchAllPreoffersBody;
  }): Promise<AxiosResponse<ListItemsResponse<PreofferItemResponse>>> {
    const { body, params } = args;

    const newData = {
      page: params.currentPage,
      size: params.pageSize,
    };
    return $api.post<ListItemsResponse<PreofferItemResponse>>(
      '/recruiting-tool/api/v1/preoffer/search',
      { ...body },
      { params: newData, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }) },
    );
  }

  static async updateCandidatePreofferInfo(id: number, data: object): Promise<AxiosResponse> {
    return $api.put(`/recruiting-tool/api/v1/preoffer/${id}`, data);
  }
}
